import React from "react";
import { Nav } from "react-bootstrap";

/**
 * Owner-locked Song Processing lifecycle tabs.
 *
 * Contract: Active | Archived only.
 * Song History is the sidebar route `/uploader-history`.
 * Do not add a History tab here — CI and npm start refuse it.
 */
export type SongProcessingLifecycleView = "active" | "archived";

export const SONG_PROCESSING_LIFECYCLE_VIEWS = [
  "active",
  "archived",
] as const satisfies readonly SongProcessingLifecycleView[];

export const SONG_PROCESSING_LIFECYCLE_TAB_LABELS = {
  active: "Active",
  archived: "Archived",
} as const;

type Props = {
  view: SongProcessingLifecycleView;
  onSelect: (next: SongProcessingLifecycleView) => void;
  activeCountLabel?: string;
  archivedCountLabel?: string;
};

const SongProcessingLifecycleTabs: React.FC<Props> = ({
  view,
  onSelect,
  activeCountLabel = "",
  archivedCountLabel = "",
}) => (
  <Nav
    variant="tabs"
    activeKey={view}
    onSelect={(key) =>
      onSelect((key as SongProcessingLifecycleView) || "active")
    }
    className="mb-3"
    data-testid="song-processing-lifecycle-tabs"
  >
    <Nav.Item>
      <Nav.Link eventKey="active">
        {SONG_PROCESSING_LIFECYCLE_TAB_LABELS.active}
        {activeCountLabel}
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link eventKey="archived">
        {SONG_PROCESSING_LIFECYCLE_TAB_LABELS.archived}
        {archivedCountLabel}
      </Nav.Link>
    </Nav.Item>
  </Nav>
);

export default SongProcessingLifecycleTabs;
